import _objectSpread from "E:\\Workspaces\\VScode\\vue3+TS\\vue\u6848\u4F8B\\cloudMusicProject-master\\node_modules\\@babel\\runtime\\helpers\\esm\\objectSpread2.js";
import { defineComponent } from "vue";
import { useState } from "@/hooks/mapGet/index.js";
import { useStore } from "vuex";
import { isShowApi } from "@/utils/isAllApi";
import PlayList from "@/components/play-list/playList.vue";
import RankOfficial from "./cpns/rankOfficial.vue";
import Loading from "@/baseui/loading/loading.vue";
export default defineComponent({
  name: "RankList",
  setup: function setup() {
    var state = useState("RankList", ["rankList", "officialList", "styleList", "globalList"]);
    var store = useStore();
    store.dispatch("RankList/getPlayListTag"); //当前页面所有请求完毕则显示页面内容

    var isShow = isShowApi(state);
    return _objectSpread(_objectSpread({}, state), {}, {
      isShow: isShow
    });
  },
  components: {
    PlayList: PlayList,
    RankOfficial: RankOfficial,
    Loading: Loading
  }
});